import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { DeleteProjectFolderPopup } from './DeleteProjectFolderPopup';

export const DELETE_PROJECT_FOLDER = Symbol('DELETE_PROJECT_FOLDER');

export const useDeleteProjectFolderPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(DELETE_PROJECT_FOLDER, DeleteProjectFolderPopup);
  });

  return useCallback(
    (projectFolder) => {
      return new Promise((resolve) => {
        popups.openPopup(DELETE_PROJECT_FOLDER, {
          projectFolder,
          onClose: () => {
            resolve();
            popups.closePopup(DELETE_PROJECT_FOLDER);
          },
        });
      });
    },
    [popups]
  );
};
